import { render, staticRenderFns } from "./OtherPaymentList.vue?vue&type=template&id=8f50e0bc&scoped=true&"
import script from "./OtherPaymentList.vue?vue&type=script&lang=js&"
export * from "./OtherPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./OtherPaymentList.vue?vue&type=style&index=0&id=8f50e0bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50e0bc",
  null
  
)

export default component.exports